import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ClickableCardsMessage from '../components/onboarding/ClickableCardsMessage'
import InfoCardMessage from '../components/onboarding/InfoCardMessage'
import MandatoryDimensionMessage from '../components/onboarding/MandatoryDimensionMessage'
import MatchScoreMessage from '../components/onboarding/MatchScoreMessage'
import PrintReportMessage from '../components/onboarding/PrintReportMessage'
import { getVariantFromScoreKey } from '../utils'

const ONBOARDING_STYLES = {
  spotlight: {
    borderRadius: 999,
    transition: 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    transition: 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  },
  tooltip: {
    borderRadius: 12,
    boxShadow:
      '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    transformOrigin: 'center'
  },
  buttonNext: {
    backgroundColor: '#4461D4',
    height: 36,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    borderRadius: 999,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#3951B8',
      transform: 'translateY(-1px)'
    }
  },
  buttonBack: {
    color: '#1660F3',
    backgroundColor: 'transparent',
    border: 'none',
    fontWeight: 500,
    fontSize: 14,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#3951B8',
      transform: 'translateY(-1px)'
    }
  }
}

export const useOnboardingTour = ({
  matchingScore,
  overall_key,
  talentName
}) => {
  const [isTourRunning, setIsTourRunning] = useState(false)
  const { t } = useTranslation()

  const ONBOARDING_STEPS = () => [
    {
      target: '.info-card-pair',
      disableBeacon: true,
      locale: {
        next: t('discover.assistant.onboarding.next'),
        back: t('discover.assistant.onboarding.back')
      },
      content: <InfoCardMessage />
    },
    {
      target: '.match-score-card',
      content: (
        <MatchScoreMessage
          matchingScore={matchingScore}
          talentName={talentName}
          variant={getVariantFromScoreKey(overall_key)}
        />
      ),
      disableBeacon: true,
      locale: {
        next: t('discover.assistant.onboarding.next'),
        back: t('discover.assistant.onboarding.back')
      }
    },
    {
      target: '.culture-insights',
      content: <ClickableCardsMessage />,
      disableBeacon: true,
      locale: {
        next: t('discover.assistant.onboarding.next'),
        back: t('discover.assistant.onboarding.back')
      }
    },
    // {
    //   target: '.discover-profile-dropdown',
    //   content: <ProfileDropdownMessage />,
    //   locale: {
    //     next: t('discover.assistant.onboarding.next'),
    //     back: t('discover.assistant.onboarding.back')
    //   }
    // },
    {
      target: '[data-joyride="print-report-button"]',
      content: <PrintReportMessage />,
      locale: {
        next: t('discover.assistant.onboarding.next'),
        back: t('discover.assistant.onboarding.back')
      }
    },
    {
      target: '.mandatory-dimension',
      content: <MandatoryDimensionMessage />,
      disableBeacon: true,
      locale: {
        next: t('discover.assistant.onboarding.discover_dimension'),
        back: t('discover.assistant.onboarding.back'),
        last: t('discover.assistant.onboarding.discover_dimension')
      }
    }
  ]

  const startTour = () => setIsTourRunning(true)
  const stopTour = () => setIsTourRunning(false)

  return {
    steps: ONBOARDING_STEPS(t),
    styles: ONBOARDING_STYLES,
    isTourRunning,
    startTour,
    stopTour,
    spotlightPadding: 32
  }
}
